export default {
  'gift.name': 'Gift',
  //Ranking gifts list
  'gift.ranking.title': 'Ranking gifts list',
  'gift.ranking.tab': 'Ranking gifts',

  'gift.ranking.order': 'Prize order',
  'gift.ranking.id': 'Gift code',
  'gift.ranking.name': 'Gift name',
  'gift.ranking.prize-name': 'Prize name',
  'gift.ranking.weekly-quantity': 'Quantity per week',
  'gift.ranking.quantity': 'Quantity',
  'gift.ranking.type': 'Gift type',
  'gift.ranking.type--artifact': 'Artifact',
  'gift.ranking.type--voucher': 'Voucher',

  'gift.ranking.button.transfer': 'Transfer gift',
  'gift.ranking.button.sortOrder': 'Sort prize order',
  'gift.ranking.button.chooseGiftWinner': 'Choose gift winner',
  'gift.confirm.delete': 'Are you sure you want to delete this gift?',
  //add/edit page
  'gift.other.title': 'Other gift list',
  'gift.other.tab': 'Other gifts',

  'addGift.name': 'Add gift',
  'addGift.ranking.title': 'Add ranking gift',
  'addGift.other.title': 'Add other gift',

  'updateGift.name': 'Update gift',
  'updateGift.ranking.title': 'Update ranking gift',
  'updateGift.other.title': 'Update other gift',

  'addGift.form.type': 'Gift type',
  'addGift.form.id': 'Gift code',
  'addGift.form.name': 'Gift name',
  'addGift.form.prize-name': 'Prize name',
  'addGift.form.quantity': 'Total gift quantity',
  'addGift.form.weekly-quantity': 'Quantity per week',
  'addGift.form.image': 'Image',
  //sort ranking gifts page
  'sortRankingGift.name': 'Sort prize order',
  'sortRankingGift.title': 'Sort prize order',

  'sortRankingGift.table.order': 'Prize order',
  'sortRankingGift.table.id': 'Gift code',
  'sortRankingGift.table.name': 'Gift name',
  'sortRankingGift.table.prize-name': 'Prize name',
  'sortRankingGift.table.weekly-quantity': 'Quantity per week',
  'sortRankingGift.table.quantity': 'Quantity',
  'sortRankingGift.table.type': 'Gift type',

  'sortRankingGift.move-top': 'Move to top',
  'sortRankingGift.move-bottom': 'Move to bottom',
  'sortRankingGift.button.saveConfirm': 'Are you sure you want to save the changes?',
  'sortRankingGift.button.discardChange': 'Are you sure you want to discard the changes?',

  //choose gift winner
  'giftGiving.title': 'Choose gift recipient',
  'giftGiving.table.title': 'Choose gift recipient',
  'giftGiving.display-table.title': 'Gift recipient list',

  'giftGiving.filter.cumulative-greenCoin': 'Accumulated green coin',
  'giftGiving.filter.week-ranking': 'Weekly ranking',
  'giftGiving.filter.overall-ranking': 'Overall ranking',

  'giftGiving.name': 'User name',
  'giftGiving.phoneNumber': 'Phone number',
  'giftGiving.accumulatedCoins': 'Accumulated green coin',
  'giftGiving.currentWeekRanking': 'Weekly ranking',
  'giftGiving.selectedWeekRanking': 'Weekly ranking',
  'giftGiving.overallRanking': 'Overall ranking',
  'giftGiving.filter': 'Filter',
  'giftGiving.filterBy': 'Filter by',
  'giftGiving.week': 'week',
  'giftGiving.rank': 'rank',
  'giftGiving.currentWeek': 'Current week',
  'giftGiving.rankingWeek': 'Select ranking week',

  'giftGiving.button.deselect': 'Deselect',
  'giftGiving.button.reward': 'Reward gift',
  'giftGiving.button.rewardConfirm': 'Are you sure you want to reward the gift?',
  //info page
  'giftInfo.name': 'Gift information',
  'giftInfo.ranking.gift.title': 'Ranking gift information',
  'giftInfo.ranking.customer.title': 'Customer list receiving ranking gifts',
  'giftInfo.other.gift.title': 'Other gift information',
  'giftInfo.other.customer.title': 'Customer list receiving other gifts',

  'giftInfo.card.id': 'Gift code',
  'giftInfo.card.name': 'Gift name',
  'giftInfo.card.type': 'Gift type',
  'giftInfo.card.quantity': 'Total gift quantity',
  'giftInfo.card.distributedQuantity': 'Distributed quantity',
  'giftInfo.card.undistributedGift': 'Undistributed gifts',
  'giftInfo.card.image': 'Image',

  'giftInfo.table.name': 'Customer name',
  'giftInfo.table.phone': 'Phone number',
  'giftInfo.table.giftSource': 'Gift source',
  'giftInfo.table.giftSource--award': 'Admin awarded',
  'giftInfo.table.giftSource--rank': 'Ranking',
  'giftInfo.table.giftSource--bonus': 'Bonus gift',
  'giftInfo.table.rewardTime': 'Reward time',

  'giftInfo.table.rank': 'Rank',
  'giftInfo.table.ranking': 'Ranking',
  'giftInfo.table.week': 'Weekly ranking',
  'giftInfo.table.greenCoin': 'Green coin',

  //Voucher

  'gift-import.code': 'Voucher code',
  'gift-import.operationStatus': 'Operating status',
  'voucher-import.title-Other': 'Enter the voucher for other gifts',
  'voucher-import.title-Ranking': 'Enter the voucher for rating gifts',
  'modal-import.file': 'Select the file',
  'modal-import.title': 'Enter the voucher for gifts',
  'voucher-import.title': 'Manage the voucher of',
  'modal-voucher-import.title': 'Enter the voucher',
  'voucher.router.name': 'Voucher converted',
  //transfer gift
  'giftTransfer.modal.ranking.title': 'Transfer ranking gift to other gifts',
  'giftTransfer.modal.other.title': 'Transfer other gift to ranking gifts',

  'giftTransfer.modal.ranking.selectGift': 'Other gift',
  'giftTransfer.modal.other.selectGift': 'Ranking gift',
  'giftTransfer.modal.selectGift.placeholder': 'Select gift',
  'giftTransfer.modal.quantity': 'Transfer quantity',
  'giftTransfer.modal.quantity.placeholder': 'Enter quantity',
  'giftTransfer.modal.button.addGift': 'Add gift',
  'giftTransfer.modal.button.transfer': 'Transfer',
  'giftTransfer.modal.warn.sufficientAmount': 'Not enough quantity to transfer',
  'gift-table.code': 'Voucher code',
  'gift-table.operationStatus': 'Operation status',

  'gift-import.title.update': 'Update operating status',
  'gift-import.content.update': 'Are you sure you want to update the chosen states?',
  'gift-import.title.delete': 'Delete voucher',
  'gift-import.content.delete': 'Are you sure you want to delete the voucher?',

  'gift-import-other.code': 'Voucher code',
  'gift-import-other.operationStatus': 'Operating status',
  'gift-import-other.receivingTime': 'Receiving time',
  'gift-import-other.createdAt': 'Extra time',
  'gift-import-other.receiveStatus': 'Acknowledgment',
  'gift-import-other.usageStatus': 'Status of use',
  'gift-import-other.receiveStatus.params':
    '{status,select, 1 {Received} 2 {Not Received} other {Unknown}}',
  'gift-import-other.usageStatus.params': '{status,select, 1 {Used} 2 {Un used} other {Unknown}}',

  'gift-import-other.Active': 'Active',
  'gift-import-other.Deactive': 'Stop operating',
  'gift-import-other.Received': 'Received',
  'gift-import-other.NotReceived': 'Not Received',
  'gift-import-other.Used': 'Used',
  'gift-import-other.NotUsed': 'Un used',

  'gift-import-ranking.total': 'Total number of voucher codes',
  'gift-import-ranking.totalReceived': 'Number of voucher codes received',
  'gift-import-ranking.totalNotReceived': 'Number of voucher codes not received',
  'gift-import-ranking.totalActive': 'Number of active voucher codes',
  'gift-import-ranking.totalDeactive': 'Number of inactive voucher codes',

  'gift-import-ranking.code': 'Voucher code',
  'gift-import-ranking.operationStatus': 'Operating status',
  'gift-import-ranking.receivingTime': 'Receiving time',
  'gift-import-ranking.createdAt': 'Extra time',
  'gift-import-ranking.receiveStatus': 'Acknowledgment',
  'gift-import-ranking.usageStatus': 'Status of use',
  'gift-import-ranking.receiveStatus.params':
    '{status,select, 1 {Received} 2 {Not Received} other {Unknown}}',
  'gift-import-ranking.usageStatus.params': '{status,select, 1 {Used} 2 {Un used} other {Unknown}}',
  'gift-import.edit': 'Update the operating status',
  'gift-import-ranking.shortLink': 'Link shortened',
  'gift-import-other.shortLink': 'Link shortened',
  'gift-table.shortLink': 'Link shortened',

  'gift-import.title.status.update': 'Update operating status',
  'gift-import.content.status.update': 'Are you sure you want to update the chosen states?',

  'gift-import.title.warning': "Can't update the voucher",
  'gift-import.content.warning':
    'You have chosen both vouchers that are operating and stopped operating so it cannot be updated',

  'gift.exchange.title': 'Gifts exchange',
  'Exchange.gifts.tab': 'Gifts exchange',
  'gift.exchange.title-name': 'List of gift exchange',
  'gift.ranking.price': 'Price',
  'gift.ranking.usedQuantity': 'Quantity used',
  'gift.ranking.businessStatus': 'Operating status',
  'gift.businessStatus.param':
    '{status,select, 1 {Available} 2 {UnActive} 3 {Expiring} 4 {Suspended} other {Unknown}}',

  'voucher-import.title-exchange': 'Voucher hill',
  'voucher-import.title-Exchange': 'Select Voucher',
  'voucher-import.title-Exchange-router': 'Voucher exchange',
  'gift-import-exchange.code': 'Code',
  'gift-import-exchange.receivingTime': 'Receiving time',
  'gift-import-exchange.createdAt': 'Extra time',
  'gift-import-exchange.shortLink': 'Link shortened',
  'gift-import-exchange.operationStatus': 'Operating status',
  'gift-import-exchange.receiveStatus': 'Acknowledgment',
  'gift-import-exchange.usageStatus': 'State use',

  'giftInfo.exchange.customer.title': 'List of customers receiving gifts',
  'giftInfo.exchange.gift.title': 'Gift information converted',
  'giftInfo.exchange.customer.title-table': 'List of customers receiving gifts',
  'addGift.exchange.title': 'Add gifts to convert',
  'addGift.form.BusinessStatus': 'Operating status',
  'addGift.form.time': 'Time',
  'addGift.form.Price': 'Price',
  // Gift by device
  'giftByDevice.tab.name': 'Gifts by Device',
  'giftByDevice.router.name': 'Gifts by Device',
  'giftByDevice.title': 'List of Gifts at Device',
  'giftByDevice.operating.status': 'Operating Status',
  'giftByDevice.operating.status.params':
    '{status,select, 1 {Available} 2 {Unavailable} other {Unknown}}',
  'giftByDevice.actions.delete.title': 'Confirm Gift Deletion',
  'giftByDevice.actions.delete.content':
    'Are you sure you want to remove this gift from the device?',
  'giftByDevice.modal.create': 'Add Gift',
  'giftByDevice.modal.update': 'Update Gift',
  'giftByDevice.modal.information': 'Gift Information',
  'giftByDevice.modal.score': 'Redemption Points',
  'giftByDevice.modal.status.available': 'Available',
  'giftByDevice.modal.status.unAvailable': 'Unavailable',
  //
  'gift.exchange2.router.name': 'Gift catalog',
  'gift.totalRewardItemInLine': 'Total linked lines',
  'gift.redeemedQuantity': 'Redeemed quantity',
  'gift.availableQuantity': 'Available quantity',
  'gift-by-device.mode.add': 'Add gift',
  'gift-by-device.mode.list': 'Gift list',
};
